import { PageContainer } from '@ant-design/pro-components'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DEFAULT_SEARCH } from '@/features/access/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'
import { AccountListPanel } from './-account-list-panel.tsx'

const accountSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(DEFAULT_SEARCH.current),
  pageSize: z.coerce.number().int().min(1).max(100).catch(DEFAULT_SEARCH.pageSize),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  query: z.string().trim().max(255).optional().catch(undefined),
  status: z.enum(['pendingApproval', 'active', 'rejected', 'suspended']).optional().catch(undefined)
})

const listQuery = createListQueryPersistence('super-mega:access:accounts:list-query', accountSearchSchema)

export const Route = createFileRoute('/_authenticated/access/accounts')({
  beforeLoad: (options) => {
    listQuery.restore(options)
  },
  component: AccountsPage,
  head: () => ({ meta: [{ title: '账号管理 · Super Mega' }] }),
  validateSearch: listQuery.validateSearch
})

function AccountsPage() {
  const { currentSession } = Route.useRouteContext()
  const navigate = Route.useNavigate()
  const { search: query, navigateSearch } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate
  })
  const canManageStatus =
    currentSession.isSuperAdmin ||
    currentSession.permissions.some((permission) => permission.startsWith('account.') && !permission.endsWith('.read'))

  return (
    <PageContainer breadcrumbRender={false} content="集中处理账号申请，并管理账号角色和登录状态。" title="账号管理">
      <AccountListPanel
        canManageRoles={currentSession.isSuperAdmin}
        canManageStatus={canManageStatus}
        canReviewApplications={currentSession.isSuperAdmin}
        navigate={navigateSearch}
        query={query}
      />
    </PageContainer>
  )
}
